import React from "react"
import { ISocialChatMessage } from "store/chat/chat.state";
import { SocialChatJsonMessage, SocialChatJsonMessageType } from "@missionlabs/smartagent-service-chat/dist/types/socialChatJsonMessage";

interface Props {
    chatMessage: ISocialChatMessage;
    previousChatMessage?: ISocialChatMessage | undefined;
    customClassName?: string;
}

const SenderNameGrouped: React.FC<Props> = ({
  chatMessage,
  previousChatMessage,
  customClassName,
}) => {
  if (
    chatMessage.Type !== "MESSAGE" ||
    (chatMessage.content as SocialChatJsonMessage).type === SocialChatJsonMessageType.MESSAGE_READ ||
    (previousChatMessage?.Type === "MESSAGE" &&
      chatMessage.ParticipantId === previousChatMessage?.ParticipantId)
  ) {
    return null;
  }
  return (
    <div className={customClassName} data-testid="sender-name-grouped">
      {chatMessage.ParticipantRole === "AGENT"
        ? "Agent: "
        : chatMessage.ParticipantRole === "CUSTOMER"
        ? "Customer: "
        : ""}
      {chatMessage.DisplayName}
    </div>
  );
};

export default SenderNameGrouped;